import { useContext } from 'react';
import { ITaxReturnEventHandlerContextValues, TaxReturnEventHandlerContext } from '../contexts/taxReturnEventHandlerContext';

export const useTaxReturnEventHandler = (): ITaxReturnEventHandlerContextValues => {
    const context = useContext(TaxReturnEventHandlerContext);

    if (!context) {
        throw new Error('useTaxReturnEventHandler must be used within a TaxReturnEventHandlerProvider');
    }

    return context;
};
